// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__hp0AZ","buttons":"PendingPaymentAlert_buttons__1IQ7B"};